if (!customElements.get('bb-catalog')) {
  customElements.define('bb-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', () => this.filter());
      this.filter();
    }
    filter() {
      const category = this.querySelector('[data-library-filter]:checked')?.value || 'all';
      let count = 0;
      this.querySelectorAll('[data-card]').forEach(card => {
        const categories = (card.dataset.libraryCategories || '').split(/\s+/);
        const show = category === 'all' || categories.includes(category);
        card.hidden = !show;
        if (show) count++;
      });
      this.querySelector('[data-result-count]').textContent = String(count);
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
  });
}
